import React, { Component } from "react";
import { modal } from "../modal";
import { openPhonecall } from "../../common/callUtil"
//import {  hideChat } from "../../lib/synalio";
import { MasterDataReady } from "../../lib/masterData/MasterDataReady";
import { DynamicContent, isVisibleContent } from "../../common/DynamicContent";

const modal_howto_contact_impl = props => {
  console.log('modal_howto_contact', props);
  const { asset, room, eventTrackingId, contactType } = props;
  //hideChat();

  const formUrl = '/hello-storage/contact/' + (asset ? '?object_cd=' + asset.assetId : '');
  const advicecardUrl = AREALINK_CO_JP_ADVICECARD_URL;
  // {room ? ' ' + room.roomName : ''}
  return (
    <div className="modal_howto_contact modal_base">
      <div className="cross" onClick={() => modal.closeModal()} />
      <div className="title">
        <span>お問い合わせの方法を</span>
        <span>選んでください</span>
        { asset && <div className="sp assetName">お電話の際【{asset.name}】とオペレータへお伝えください。</div> }
      </div>
      <div className="collection" id="contact_select">
        {contactType.phoneNumber && <a
          onClick={() => openPhonecall(contactType.slug, eventTrackingId, asset, room)}
          className="item"
        >
          <img src="resource/img/big_phone.png" />
          <div>電話</div>
        </a>}
        {contactType.showForm && <a
          href={formUrl}
          target="_blank"
          className="item"
        >
          <img src="resource/img/envelope.png" />
          <div>メール</div>
        </a>}
        {contactType.showAdviceCard && (
          <a
            href={advicecardUrl}
            target="_blank"
            className="item"
          >
            <img src="resource/img/advice_card.png" />
            <div>アドバイスカード</div>
          </a>
        )}
      </div>
      <p className="collection_paragraph">
        <a onClick={e => {
          e.preventDefault();
          modal.back();
        }}>
          <img src="resource/img/s_arrow_left.png" />前の画面に戻る
        </a>
      </p>
    </div>
  );
};

export const modal_howto_contact = props => {
  return <MasterDataReady schemaIds={["excComment"]} render={() => {
    if (isVisibleContent(masterData.excComment.modalVisitor)) {
      const { type } = props;
      return (
        <div className="modal_howto_contact modal_base">
          <div className="cross" onClick={() => modal.closeModal()} />
          <DynamicContent params={masterData.excComment.modalVisitor} type={type}></DynamicContent>
        </div>
      );
    } else {
      return modal_howto_contact_impl(props);
    }
  }}>
  </MasterDataReady>
};



// WEBPACK FOOTER //
// ./common/modal/modal_howto_contact.jsx